

import { Location, CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Subject, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UserService } from 'src/app/services/UserService';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { SearchData } from 'src/app/services/searchData';
import { WorkExperience } from 'src/app/services/userModel';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { NgSelectModule } from '@ng-select/ng-select';
import { PricePlanService } from '../Price-subscritions/priceplanService';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;
@Component({
  selector: 'app-candidate-template',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule,
NgSelectModule, NgxSummernoteModule, ImageCropperModule,DndDirective,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './candidate-template.component.html',
  styleUrls: ['./candidate-template.component.scss']
})
export class CandidateTemplateComponent extends FormValidation implements OnInit, OnChanges {
  private wasInside = false;
  public FORMERROR = super.Form;
  @Output() candidateReload = new EventEmitter<any>()
  selectedCurrency: string = '';
  tempFile: any;
  rtrformgrp: UntypedFormGroup;
  candidateSupplyRef: BsModalRef;
  @Output() candidateListing = new EventEmitter();
  filterStatusList: { itemId: any; value: any; }[] = [];
  @Input() loadAPIcall: boolean;
  filterloadSubcription: Subscription;
  selectedFiles: File[] = [];
  removeFile(event) {
    event.stopPropagation();
    this.selectedFiles = [];
    const fileInput = $("#fileDropRef")[0] as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  clickInside() {
    this.wasInside = true;
  }


  @Input() passValues: Array<candidateModel> = [];


  @Input() responseReceived: any;
  @Input() viewSize: any;
  @Input() removeSelected: any;
  @Input() jobData: any;
  @Input() Obj: any;
  @Input() updateCandidateModule: jobModuleConfig;
  passCandidateData: any;
  @Input() removeTag: any;
  profileDetailResponse: any;

  @Input() candidatesFoundStatus: any;
  @Input() fromApply: boolean = false;
  CandiIdHighLight: any
  userId = localStorage.getItem("userId")
  appSettings: AppSettings
  submited: boolean = false;
  showmodel = false

  userType = localStorage.getItem('userType');
  removetagValueget: any;
  flag: boolean = true;
  filtersApplied: boolean = false
  @Input() data: any;
  @Input() dataPasstoSkillwidgets: any[];
  url = AppSettings.photoUrl;
  Resurl = AppSettings.ServerUrl;
  updateDate: any = [];
  jobfilter: boolean = false;
  GigsumoConstant = GigsumoConstants;
  unit = { duration: '30' };
  @Output() selectedCandidate: EventEmitter<any> = new EventEmitter()
  @Output() removeSeletedUser: EventEmitter<any> = new EventEmitter()
  @Output() updateStatusAndFilters: EventEmitter<any> = new EventEmitter()
  @ViewChild("myFileInputcandidate") myFileInputcandidate;
  dataget
  checkcount: number = 0;
  checkedList: any = [];
  FormData: any;
  PrimaryResumeFormData: any;

  fileSize = AppSettings.FILE_SIZE;
  clickItemActive: any;
  @Output() suggjob: EventEmitter<any> = new EventEmitter()
  bsModalRef: BsModalRef;
  public envName: any = environment.name;
  @ViewChild("myFileInput") myFileInput;
  @ViewChild("myFileInput1") myFileInput1;
  @ViewChild("myFileInput2") myFileInput2;
  imageChangedEvent: any = "";
  fileUploadName;
  fileToUpload: File;

  photoId: any;
  totaljobcount: any
  infoData: any = {};
  photo: any = null;
  fileshow = undefined;
  object: any;
  download = environment.serverUrl + "/download/"
  seletedChatItem;
  messageData: any;
  @ViewChild('candidateTemplate', { static: false }) candidateTemplate: TemplateRef<any>;
  messagemodelflag: any
  loadscribtion: Subscription;
  currentTimeDate: string | Date;
  loadDate: any = [];
  API: any;
  tempData: any = [];
  networkflag: boolean = false
  firstName: any;
  lastName: any;
  creditPoints: any;
  primaryEmail: any;
  jobCountry: string;
  targetRates: string;
  jobPayType: string;
  selectedJobTitle: string;
  filtersAppliedbtn: boolean = true;
  items: any = {
  };
  clickEventsubscription: Subscription;
  updateCandidateListSubx: Subscription;
  focus: string;




  BackBreadCream() {
    this._location.back();
  }

  LandingPage() {
    this.router.navigate(["landingPage"]);
  }
  rtrpayType: any;
  observableFinalised: boolean = false;
  jobId: any;
  jobPostedBehalfOf: any
  ngunsubscribe = new Subject();
  createSubjectSubscription: Subscription;
  termCheckSubscription: Subscription;
  selectedItem: any;

  itemsLoaded: boolean = false;
  constructor(private JobServicecolor: JobService, private planService: PricePlanService, private cdr: ChangeDetectorRef, private userService: UserService, private apiService: ApiService,
    private commonValues: CommonValues,
    private formBuilder: UntypedFormBuilder, private searchData: SearchData, private _location: Location, private modalService: BsModalService,
    private router: Router, public util: UtilService, private a_route: ActivatedRoute, private candidateService: CandidateService,
    public gigsumoService: GigsumoService) {
    super();

    this.userId = localStorage.getItem('userId');
  }
  activejobcount: number;
  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.passValues && changes.passValues.currentValue != undefined) {
      this.passValues = changes.passValues.currentValue;
    }
    if (changes.Obj && changes.Obj.currentValue) {
      this.selectedItem = changes.Obj.currentValue.candidateId;
    }
    if (changes.candidatesFoundStatus && changes.candidatesFoundStatus.currentValue) {
      this.candidatesFoundStatus = changes.candidatesFoundStatus.currentValue;

    }
  }

  config2 = {
    focus: false,
    height: 150,
    placeholder: "",
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style:
      "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html("");
        }
      },
      onKeydown: function (e) {
        var t: string = e.currentTarget.innerText;
        var words = t.split(" ");

      }
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      [
        "font",
        [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "superscript",
          "subscript",
          "clear",
        ],
      ],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: [
      "Helvetica",
      "Arial",
      "Arial Black",
      "Comic Sans MS",
      "Courier New",
      "Roboto",
      "Times",
    ], onPaste(e) {
      const buffertext = (e.originalEvent || e).clipboardData.getData("text");
      e.preventDefault();
      const all = buffertext.trim();
      document.execCommand("insertText", false, all.substring(0, 1000));
    },
  };
  //resume download function on edit candidate by monisha
  onDownload() {
    const file: File = this.tempFile;
    const fileName = file.name;
    if (file.name) {
      this.downloadFile(file, fileName);
    } else {
      const fileUrl = `${this.Resurl}download/${this?.EditCandidatFile?.fileId}`;
      fetch(fileUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error("File download failed");
          }
          return response.blob();
        })
        .then(blob => {
          const fileName = this?.EditCandidatFile?.fileName || "downloaded-file.pdf";
          this.downloadFile(blob, this.getFileName(fileName));
        })
        .catch(error => console.error("Error downloading file:", error));
    }


  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement("a");
    const blobUrl = URL.createObjectURL(blob);

    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup memory
    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
  }



  figureLength: number = 0;
  payType: any = null;
  typeTargetValue: any = null;
  targetRate: any;
  countryChosen: any = null;
  onChangePayType(value, param) {
    this.payType = value
    // if (this.countryChosen != null) {
    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }
    // }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue, param)
    }
  }


  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }
  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }

  // for first and last name
  getInitialName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  // for first and last name
  getColorName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }

  scrollToFirstInvalidControl() {
    const firstInvalidControl = document.querySelector('form .ng-invalid') as HTMLElement;
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }










  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    // scroll
  };
  candidateJobTitleList: any = [];
  modalRef: BsModalRef;
  otherStatesList: any = [];
  candidatePostForm: UntypedFormGroup;
  get candidateControls() {
    return this.candidatePostForm.controls
  }
  EditCandidatFile: any
  currentOrganizationDetail: WorkExperience;
  async opencandidateModal(item) {

    try {
      this.disable_for_draft = false;
      this.candidateSubmit = false;
      this.updateDate = [];
      this.userType = localStorage.getItem('userType')
      const data: any = {
        userId: localStorage.getItem('userId'),
        userType: localStorage.getItem('userType')
      };

      this.util.startLoader();

      const profileDetails = await this.apiService.create('user/profileDetails', data).toPromise();

      this.util.stopLoader();

      const currentOrganization: Array<WorkExperience> = profileDetails.data.exeperienceList;
      if (currentOrganization && currentOrganization.length > 0) {
        currentOrganization.forEach(workExp => {
          if (workExp.currentOrganization) {
            this.currentOrganizationDetail = workExp;
          }
        });
      }

      this.currentTimeDate = profileDetails.data.currentTimeByTimezone;
      this.firstName = profileDetails.data.userData.firstName;
      this.lastName = profileDetails.data.userData.lastName;
      this.primaryEmail = profileDetails.data.userData.email;

      this.object = item;
      this.fileshow = undefined;

      await this.inititateCandidateForm();
      if (this.candidateTemplate) {
        this.modalRef = this.modalService.show(this.candidateTemplate, {
          backdrop: 'static',
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'modal-small'
        });
      }
      if (item?.resumes) {
        item?.resumes?.forEach(element => {
          if (element.isDefault) {
            this.fileDragdrop = element;
            this.tempFile = element;
            this.resumeupload = element;
            this.EditCandidatFile = element
          }
        });
      }
      if (item.primarySkills && item.primarySkills.length > 0) {
        this.primarySkillsSelected = [...item.primarySkills];
      }

      if (item.secondarySkills && item.secondarySkills.length > 0) {
        this.secondarySkillsSelected = [...item.secondarySkills];
      }

      if (item.otherPreferedStates && item.otherPreferedStates.length > 0) {
        this.otherSelectedStates = [...item.otherPreferedStates];
      }

      if (item.targetRate == 0) {
        item.targetRate = '';
      }
      item.totalExperience = item.totalExperience === 0 ? null : item.totalExperience;
      item.email = item.candidateEmailId;

      const selectedNetworks = [
        ...(this.object.personalNetworksPublished || []),
        ...(this.object.memberNetworksPublished || []),
        ...(this.object.businessNetworksPublished || []),
      ];
      if (this.object.postedToMarketPlace) {
        selectedNetworks.push({ id: '1', name: 'Marketplace' });
      }

      const networkIds = selectedNetworks.map(network => network.id || network);

      // Patch form values after lists are loaded and DOM is ready
      // Use setTimeout to allow Angular to render the select options first
      setTimeout(() => {
        // Force change detection to render the select options
        this.cdr.detectChanges();

        // Patch all form values
        this.candidatePostForm.patchValue({
          ...this.object,
          selectedNetworks: networkIds,
        });

        // Explicitly set dropdown values that might not have been set
        if (item.availableIn) {
          this.candidatePostForm.get('availableIn').setValue(item.availableIn);
        }
        if (item.engagementType) {
          this.candidatePostForm.get('engagementType').setValue(item.engagementType);
          this.onEngagementTypeChange(item.engagementType);
        }
        if (item.payType) {
          this.candidatePostForm.get('payType').setValue(item.payType);
        }

        // Load country-specific data (work authorization list) and set the value
        this.loadCountrySpecificData(item.country, item.workAuthorization);

        if (this.userType == 'JOB_SEEKER') {
          // JOB_SEEKER's email field is disabled (derived from the user account),
          // so patchEmail()/(input) never fires to sync candidateEmailId. Patch it
          // explicitly here so the candidate entity persists the email (otherwise the
          // profile panel shows "-"). See patchEmail() which is skipped for JOB_SEEKER.
          this.candidatePostForm.patchValue({'firstName': this.firstName, 'lastName': this.lastName, 'email': this.primaryEmail, 'candidateEmailId': this.primaryEmail});
          this.candidatePostForm.get('email').disable();
          this.candidatePostForm.get('firstName').disable();
          this.candidatePostForm.get('lastName').disable();
        }

        // Force change detection to update the view
        this.cdr.detectChanges();
      }, 100);
    } catch (error) {
      this.util.stopLoader();
    }
  }


  getFileName(name: string) {
    const index = name.indexOf('_');
    return index !== -1 ? name.substring(index + 1) : name;
  }

  // Name to show in the upload-preview chip (+ its tooltip). A freshly picked
  // local file (fileDragdrop.file is a native File) has a raw filename with no
  // storage prefix, so show it as-is — otherwise getFileName() would strip the
  // portion before the first underscore and make a long name look truncated
  // from the front. Only a pre-existing server resume carries the "<prefix>_"
  // storage token that getFileName() is meant to remove.
  getUploadDisplayName(fileDragdrop: any): string {
    if (!fileDragdrop) {
      return '';
    }
    const rawName = fileDragdrop.fileName || fileDragdrop.name || '';
    if (fileDragdrop.file) {
      return rawName;
    }
    return this.getFileName(rawName);
  }

  async inititateCandidateForm() {
    try {
      this.getCountries();
      this.generateYears();
      await this.getListValues('CANDIDATE');
      this.searchData.setCommonVariables(this.commonVariables);
      this.candidatePostForm = new AppSettings().getEditCandidateGroup();
      if (this.userType === 'student' || this.userType === 'JOB_SEEKER') {
        this.candidatePostForm.get('candidateEmailId').clearValidators();
        this.candidatePostForm.get('candidateEmailId').updateValueAndValidity();
      }
    } catch (error) {
    }
  }

  candidateSubmit: boolean = false



  primarySkillsSelected = [];
  secondarySkillsSelected = [];

  // ng-select's clear-all (the "x" on the field) only marks itself for check.
  // Its dropdown panel is a separate OnPush child that keeps the same [items]
  // reference, so the option rows kept showing the old checked state until the
  // mouse moved over the list. Hand the panel a fresh array reference on clear
  // so it re-renders at once.
  onSkillsCleared(field: 'primary' | 'secondary') {
    if (field === 'primary') {
      this.primarySkillsList = [...this.primarySkillsList];
    } else {
      this.secondarySkillsList = [...this.secondarySkillsList];
    }
  }
  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];
  submit: boolean = false
  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.apiService.query("country/getAllCountries").subscribe((res) => {
      // this.util.stopLoader();
      res.forEach((ele) => {
        this.countryList.push(ele);
      });
    }, err => {
      this.util.stopLoader();
    });
  }

  checkspace(event: any): boolean {
    return super.validSpace(event);
  }

  years: any = []
  generateYears() {
    // var max = new Date().getFullYear();
    // var min = max - 80;
    for (var i = 0; i <= 20; i++) {
      this.years.push(i);
    }
  }

  organizationList: any = []
  primarySkillsList: any = []
  secondarySkillsList: any = []
  skillsList: any = []
  payTypeList: any = []
  clientTypeList: any = []
  clientNameList: any = []
  clientNameList1: any = []
  durationTypeList: any = []
  usStatesList = []
  jobClassificationList: any = []
  commonVariables: any = {};
  totalExperienceList = []
  periodList = []

  recruiterTitleList: any = []
  engagementTypeList = []
  workAuthorizationList: any = []
  jobPostForm: UntypedFormGroup;
  currentTime: any;
  maxDate: any
  isSelected(id: number): boolean {
    return this.gigsumoService.isSelected(id, this.selectedNetworks);
  }

  onCheckboxChangenetwork(id: number, checked: boolean, form: FormGroup): void {
    this.selectedNetworks = this.gigsumoService.onCheckboxChange(
      id,
      checked,
      this.selectedNetworks,
      form,
      'selectedNetworks'
    );
  }

  // Prevent Free plan users and Job Seekers from unchecking Marketplace
  onNetworkSelectionChange(form: FormGroup): void {
    // Strip disabled networks (safety net)
    this.selectedNetworks = this.selectedNetworks.filter((n: any) => {
      const network = this.networkGroups.find((g: any) => String(g.id) === String(n?.id || n));
      return !network?.disabled;
    });
    // Re-add locked networks if removed
    this.lockedNetworkIds.forEach(lockedId => {
      if (!this.selectedNetworks.some((n: any) => String(n?.id || n) === lockedId)) {
        this.selectedNetworks = [...this.selectedNetworks, lockedId];
      }
    });
    // Prevent Free plan / Job Seeker users from unchecking Marketplace
    if ((this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') && this.selectedNetworks != null) {
      const hasMarketplace = this.selectedNetworks.some((id: any) => id === '1' || id === 1);
      if (!hasMarketplace) {
        this.selectedNetworks = ['1', ...this.selectedNetworks];
      }
    }
    form.get('selectedNetworks')?.setValue(this.selectedNetworks);
  }

  selectedNetworks: any[] = [];
  networkGroups: any[] = [];
  networks: any[] = [];
  membershipType = localStorage.getItem('MemberShipType');
  groupedNetworks: any = {};
  lockedNetworkIds: Set<string> = new Set();
  disabledNetworkTypes: Set<string> = new Set();

  isNetworkLocked(networkId: any): boolean {
    return this.lockedNetworkIds.has(String(networkId));
  }

  isNetworkDisabledByPermission(network: any): boolean {
    if (!network) return false;
    if (network.id === '1') return this.disabledNetworkTypes.has('Marketplace');
    return this.disabledNetworkTypes.has(network.type);
  }

  getListValues(param): Promise<void> {
    return new Promise((resolve, reject) => {
    // Only reset lists if we're going to make the API call
    // This prevents clearing already-loaded lists on subsequent modal opens
    if (this.jobClassificationList.length == 0) {
      this.clientTypeList = []
      this.payTypeList = []
      this.secondarySkillsList = []
      this.primarySkillsList = []
      this.skillsList = []
      this.periodList = []
      this.recruiterTitleList = []
      this.totalExperienceList = []
      this.workAuthorizationList = []
      this.durationTypeList = []
      this.engagementTypeList = []
      this.util.startLoader()
      var data: any = { "domain": "ENGAGEMENT_TYPE,CLIENT_TYPE,PAY_TYPE,DURATION,PRIMARY_SKILLS,WORK_AUTHORIZATION,CANDIDATE_AVAILABLITY,TOTAL_EXPERIENCE,SECONDARY_SKILLS,GIGSUMO_SKILLS_LIST,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST,EFFECTIVE_FOR" }
      data.userId = localStorage.getItem("userId");
      data.type = "NETWORKS"
      this.apiService.create('listvalue/findbyList', data).subscribe(res => {
        if (res.code == '00000') {
          const data = res.data;
          const businessNetworks = data.businessNetworks ? data.businessNetworks.map((network: any) => ({
            id: network.b2bNetworkId,
            name: network.b2bNetworkName,
            type: 'Business Networks'
          })) : [];

          const memberNetworks = data.memberNetworks ? data.memberNetworks.map((network: any) => ({
            id: network.businessNetworkId,
            name: network.businessNetworkName,
            type: 'Member Networks'
          })) : [];

          const personalNetworks = data.personalNetworks ? data.personalNetworks.map((network: any) => ({
            id: network.networkId,
            name: network.networkName,
            type: 'Personal Networks'
          })) : [];
          const allNetworks = [...businessNetworks, ...memberNetworks, ...personalNetworks];

          this.networks = allNetworks;
          // Group networks by type
          this.groupedNetworks = allNetworks.reduce((groups: any, network: any) => {
            const { type } = network;
            if (!groups[type]) {
              groups[type] = [];
            }
            groups[type].push(network);
            return groups;
          }, {});
          this.networkGroups = Object.keys(this.groupedNetworks).reduce((result: any[], type: string) => {
            return result.concat(this.groupedNetworks[type].map((network: any) => ({
              ...network,
              type
            })));
          }, []);
          const marketplaceNetwork = {
            id: '1', // Assign a unique ID
            name: 'Marketplace',
            type: 'Marketplace'
          };
          this.networkGroups = [marketplaceNetwork, ...this.networkGroups];

          // Pre-select Marketplace for Free plan users and Job Seekers
          if (this.membershipType === 'Free' && this.selectedNetworks!=null || this.userType === 'JOB_SEEKER' && this.selectedNetworks!=null) {
            const hasMarketplace = this.selectedNetworks.some(id => id === '1' || id === 1);
            if (!hasMarketplace) {
              this.selectedNetworks = ['1', ...this.selectedNetworks];
            }
          }

          // Apply org-level publish settings (locked + disabled networks)
          const bizId = localStorage.getItem('myBusinessId');
          if (bizId) {
            this.apiService.query(`business/getNetworkPermissions?businessId=${bizId}`).subscribe({
              next: (settingsRes: any) => {
                const sData = settingsRes?.data || {};
                const schedule: any[] = sData.publishSchedule || [];
                const day1Step = schedule.find((s: any) => s.day === 1);
                const day1Ids: string[] = day1Step
                  ? [
                      ...((day1Step.b2bNetworkIds as string[]) || []),
                      ...((day1Step.personalNetworkIds as string[]) || []),
                      ...((day1Step.memberNetworkIds as string[]) || []),
                      ...(day1Step.marketplace ? ['1'] : [])
                    ]
                  : [];
                this.lockedNetworkIds = new Set<string>(day1Ids.map(String));
                day1Ids.forEach(id => {
                  if (!this.selectedNetworks.some((n: any) => String(n?.id || n) === id)) {
                    this.selectedNetworks = [...this.selectedNetworks, id];
                  }
                });
                const perms = sData.networkPermissions;
                this.disabledNetworkTypes = new Set<string>();
                if (perms) {
                  if (perms.personalNetworks === false) this.disabledNetworkTypes.add('Personal Networks');
                  if (perms.memberNetworks === false) this.disabledNetworkTypes.add('Member Networks');
                  if (perms.b2bNetworks === false) this.disabledNetworkTypes.add('Business Networks');
                  if (perms.marketplace === false) this.disabledNetworkTypes.add('Marketplace');
                }
                this.networkGroups = this.networkGroups.map((n: any) => ({
                  ...n,
                  disabled: this.isNetworkDisabledByPermission(n)
                }));
              },
              error: () => {}
            });
          }

          if (this.networkGroups.length > 0) {
            // Step 1: Get all selected network IDs from object
            const selectedNetworks = [
              ...(this.object.personalNetworksPublished || []),
              ...(this.object.memberNetworksPublished || []),
              ...(this.object.businessNetworksPublished || []),
            ];

            console.log("selectedNetworks", selectedNetworks);

            // Step 2: Get all valid (active) network IDs from networkGroups
            const validIds = this.networkGroups.map(group => group.id);

            console.log("validIds", validIds);

            // Step 3: Filter out any selected IDs that are no longer valid
            const filteredSelectedIds = selectedNetworks.filter(id => validIds.includes(id));
            console.log("filteredSelectedIds", filteredSelectedIds);
            const marketplaceId = 1;

            // Log your current selectedNetworks
            console.log('Checking for marketplaceId:', marketplaceId);
            console.log('Current selectedNetworks:', this.selectedNetworks);

            // Step: Check if already added
            const isAlreadyAdded = this.selectedNetworks?.some((datass: any) => {
              const value = datass?.id || datass;
              console.log('Checking item:', datass, '-> ID:', value);
              return value === marketplaceId;
            });

            console.log('Is Marketplace already added?', isAlreadyAdded);

            // Step 3: Patch only after final list is ready (if form exists)
            if (this.candidatePostForm) {
              this.candidatePostForm.patchValue({
                networks: (this.selectedNetworks || []).map((item: any) => item?.id || item)
              });
            }

          }


          this.currentTime = new Date(res.data.currentTime);
          this.maxDate = new Date(this.currentTime);
          if (param == 'CANDIDATE') {
            this.usStatesList = []
            this.apiService
              .query("country/getAllStates?countryCode=US")
              .subscribe((res) => {
                if (res) {
                  res.forEach(ele => {
                    this.usStatesList.push(ele.stateName)
                    this.otherStatesList.push(ele.stateName)
                  })
                }
              }, err => {
                this.util.stopLoader();
              })
          }
          res.data.CLIENT_TYPE.listItems.forEach(ele => {
            this.clientTypeList.push(ele.item)
            var mySet = new Set(this.clientTypeList);
            this.clientTypeList = [...mySet]
          })
          res.data.PAY_TYPE.listItems.forEach(ele => {
            this.payTypeList.push(ele.item)
            var mySet = new Set(this.payTypeList);
            this.payTypeList = [...mySet]
          })
          res.data.GIGSUMO_SKILLS_LIST.listItems.forEach(ele => {
            this.skillsList.push(ele.item)
            var mySet = new Set(this.skillsList);
            this.skillsList = [...mySet]
          })

          res.data.CANDIDATE_AVAILABLITY.listItems.forEach(ele => {
            this.periodList.push(ele.item)
            var mySet = new Set(this.periodList);
            this.periodList = [...mySet]
          })
          res.data.TOTAL_EXPERIENCE.listItems.forEach(ele => {
            this.totalExperienceList.push(ele.item)
            var mySet = new Set(this.totalExperienceList);
            this.totalExperienceList = [...mySet]
          })
          res.data.ENGAGEMENT_TYPE.listItems.forEach(ele => {
            this.engagementTypeList.push(ele.item)
            var mySet = new Set(this.engagementTypeList);
            this.engagementTypeList = [...mySet]
          })

          res.data.PRIMARY_SKILLS.listItems.forEach(ele => {
            if (ele.item) {
              this.primarySkillsList.push(ele.item)
              var mySet = new Set(this.primarySkillsList);
              this.primarySkillsList = [...mySet]
            }
          })
          res.data.SECONDARY_SKILLS.listItems.forEach(ele => {
            if (ele.item) {
              this.secondarySkillsList.push(ele.item)
              var mySet = new Set(this.secondarySkillsList);
              this.secondarySkillsList = [...mySet]
            }
          })

          res.data.DURATION.listItems.forEach(ele => {
            this.durationTypeList.push(ele.item)
            var mySet = new Set(this.durationTypeList);
            this.durationTypeList = [...mySet]
          })
          res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
            this.candidateJobTitleList.push(ele.item);
            var mySet = new Set(this.candidateJobTitleList);
            this.candidateJobTitleList = [...mySet]
          })
          res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
            this.recruiterTitleList.push(ele.item)
            var mySet = new Set(this.recruiterTitleList);
            this.recruiterTitleList = [...mySet]
          })
          this.util.stopLoader();
          resolve();
        }
      }, err => {
        this.util.stopLoader();
        reject(err);
      })
    } else {
      resolve();
    }
    });
  }

  workflag: boolean = false;
  onChangeCountry(event, param) {

    this.countryChosen = event;
    if (this.candidatePostForm == undefined) {
      this.inititateCandidateForm();
      setTimeout(() => {
        this.candidatePostForm.get('workAuthorization').enable();
      }, 1500);

    }

    if (param == 'candidates') {
      this.candidatePostForm.get('city').patchValue(null)
      this.candidatePostForm.get('state').patchValue(null)
      this.candidatePostForm.get('zipCode').patchValue(null)
    }

    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 3
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }
    if (event == "US" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();

      this.selectedCountries = true
      const countryCode = event;
      this.util.startLoader()
      this.workAuthorizationList = []
      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_US').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });

          this.apiService
            .query("country/getAllStates?countryCode=" + countryCode)
            .subscribe((res) => {
              this.usStatesList = [];
              res.forEach(ele => {
                this.usStatesList.push(ele.stateName);
              })
            }, err => {
              this.util.stopLoader();
            });

        }
      })

    } else if (event == "AU" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();

      this.util.startLoader()
      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_AU').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          })

          this.selectedCountries = true
          const countryCode = event;
          if (this.stateListAU.length == 0) {
            this.stateListAU = [];
            this.apiService
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListAU = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else if (event == "IN" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.util.startLoader()
      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_IN').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });

          this.selectedCountries = true;
          const countryCode = event;
          if (this.stateListIN.length == 0) {
            this.stateListIN = [];

            this.apiService
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListIN = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else if (event == "CA" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();

      this.util.startLoader()
      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_CA').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });
          this.selectedCountries = true
          const countryCode = event;

          if (this.stateListCA.length == 0) {
            this.apiService
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListCA = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })

    } else {
      this.selectedCountries = false;
      if (event != null && this.candidatePostForm != undefined) {
        this.workflag = true;
        this.workAuthorizationList = [];
        if (this.countryChosen != 'US' || this.countryChosen != 'AU' || this.countryChosen != 'IN' || this.countryChosen != 'CA') {

          setTimeout(() => {
            this.candidatePostForm.get('workAuthorization').patchValue(null)
            this.candidatePostForm.get('workAuthorization').disable();
            this.candidatePostForm.get('workAuthorization').clearValidators();
            this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
          }, 1000);

        }

      }

    }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue, param)
    }

  }


  selectedCountries: boolean = false
  onTargetRateTyped(value, param) {
    this.typeTargetValue = value

  }

  // Load country-specific data (work authorization, states) without clearing form values
  // This is called after patchValue to preserve the candidate's existing values
  loadCountrySpecificData(country: string, workAuthValue?: string) {
    if (!country) return;

    this.countryChosen = country;

    if (country === "US" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required]);
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.selectedCountries = true;

      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_US').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item);
          });
          this.workAuthorizationList = [...new Set(this.workAuthorizationList)];
          // Set value after list is loaded
          if (workAuthValue && this.candidatePostForm) {
            this.candidatePostForm.get('workAuthorization').setValue(workAuthValue);
          }
          this.cdr.detectChanges();
        }
      });

      this.apiService.query("country/getAllStates?countryCode=US").subscribe((res) => {
        this.usStatesList = [];
        res.forEach(ele => {
          this.usStatesList.push(ele.stateName);
        });
        this.cdr.detectChanges();
      });

    } else if (country === "AU" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required]);
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.selectedCountries = true;

      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_AU').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item);
          });
          this.workAuthorizationList = [...new Set(this.workAuthorizationList)];
          // Set value after list is loaded
          if (workAuthValue && this.candidatePostForm) {
            this.candidatePostForm.get('workAuthorization').setValue(workAuthValue);
          }
          this.cdr.detectChanges();
        }
      });

      if (this.stateListAU.length == 0) {
        this.apiService.query("country/getAllStates?countryCode=AU").subscribe((res) => {
          this.stateListAU = res;
          this.cdr.detectChanges();
        });
      }

    } else if (country === "IN" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required]);
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.selectedCountries = true;

      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_IN').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item);
          });
          this.workAuthorizationList = [...new Set(this.workAuthorizationList)];
          // Set value after list is loaded
          if (workAuthValue && this.candidatePostForm) {
            this.candidatePostForm.get('workAuthorization').setValue(workAuthValue);
          }
          this.cdr.detectChanges();
        }
      });

      if (this.stateListIN.length == 0) {
        this.apiService.query("country/getAllStates?countryCode=IN").subscribe((res) => {
          this.stateListIN = res;
          this.cdr.detectChanges();
        });
      }

    } else if (country === "CA" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required]);
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.selectedCountries = true;

      this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_CA').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item);
          });
          this.workAuthorizationList = [...new Set(this.workAuthorizationList)];
          // Set value after list is loaded
          if (workAuthValue && this.candidatePostForm) {
            this.candidatePostForm.get('workAuthorization').setValue(workAuthValue);
          }
          this.cdr.detectChanges();
        }
      });

      if (this.stateListCA.length == 0) {
        this.apiService.query("country/getAllStates?countryCode=CA").subscribe((res) => {
          this.stateListCA = res;
          this.cdr.detectChanges();
        });
      }

    } else {
      this.selectedCountries = false;
      if (country != null && this.candidatePostForm != undefined) {
        this.workflag = true;
        this.workAuthorizationList = [];
        this.candidatePostForm.get('workAuthorization').disable();
        this.candidatePostForm.get('workAuthorization').clearValidators();
        this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      }
    }
  }


  uploadPhotoHere() {
    this.myFileInput2.nativeElement.click();
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  modalRef2: BsModalRef | null;
  fileChangeEvent(event, popupName): void {
    const checkSize = super.checkImageSize(event.target.files[0]);
    this.imageChangedEvent = event;
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (checkSize > 10) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      this.myFileInputcandidate.nativeElement.value = null;
    }
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      this.myFileInput2.nativeElement.value;

      const numberOfFiles = event.target.files.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {

          this.fileshow = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }


    }

    if (!acceptedImageTypes.includes(event.target.files[0].type)) {
      Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
      this.myFileInput2.nativeElement.value = "";
      this.modalRef.hide();
    } else {
      this.PopupServicevlaues(popupName);
    }

  }
  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }


  croppedImage: any = "";

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;


    const byteString = window.atob(
      event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });

    this.fileToUpload = new File([blob], this.fileUploadName, {
      type: "image/jpeg",
    });
  }


  closePhoto2() {
    this.modalRef2.hide();
    this.photo = null;
    this.fileshow = undefined;
    this.myFileInput2.nativeElement.value = null;
    this.photoId = null;

  }
  img: any = {};
  img4: any = {};

  imageLoaded2() {
    this.util.startLoader();
    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileUploadName);
    // setTimeout(() => {
    this.apiService.create("upload/image", formData).subscribe((res) => {
      this.util.stopLoader();
      if (res) {
        this.photoId = res.fileId;
        this.modalRef2.hide();

      }
    }, err => {
      this.util.stopLoader();

    });
  }
  resumeupload;

  fileDragdrop: any;

  // Upload progress tracking
  uploadProgress: number = 0;
  isUploading: boolean = false;

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0]; // Get the first file

    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      $("#fileDropRef")[0].value = '';
      return;
    }

    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      this.resumeupload = file;
    } else {
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  onFileDropped($event) {
    // $event from drag and drop is usually an array of files
    if ($event && $event.length > 0) {
      this.prepareFilesList($event); // Pass the array directly
    }
  }

  onChangePeriod(value) {

  }

  patchEmail() {
    this.candidatePostForm.patchValue({
      candidateEmailId: this.candidatePostForm.value.email
    })
    if (localStorage.getItem("userType") != "JOB_SEEKER") {
      this.emailidcehck(this.candidatePostForm.value.email);
    }
  }

  emailidcehck(id) {
    this.apiService.query("user/checkMailAlreadyExists/" + id).subscribe((res) => {
      if (res.data != undefined && res.data.exists != undefined) {
        if (res.data.exists) {
          setTimeout(() => {
            this.candidatePostForm.get('email').reset();
            Swal.fire({
              icon: "info",
              title: "There already exists an account registered with this email address, Please enter different email",
              showConfirmButton: true,
            });
          }, 500);

        }

      }
    })

  }
  closemodel() {
    this.modalRef.hide();
  }
  efftiveselecteddateCandidate: any;
  formatDates(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;

    }

    return [year, month, day].join('/');
  }




  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }


  // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  //  Step-by-step code integration summary for the status update from update candidate page profile   

  // 1. Replaced updateCandidate() with new version code
  // 2. Added handleDraftConfirmation() for draft confirmation modal
  // 3. Added resetDraftForm() to reset form on cancel draft
  // 4. Updated updateCandidateAfterValidation() to:
  //    - Patch organisationId
  //    - Categorize network types
  //    - Pass final data to saveCandidate()
  // 5. Added saveCandidate() to:
  //    - Create FormData
  //    - Attach resume, photo, and candidate JSON
  //    - Call API to update candidate
  // 6. Added afterSaveSuccess() to:
  //    - Show Swal success
  //    - Emit update event
  //    - Hide modal
  // 7. Verified:
  //    - All patch values are applied (photo, createdBy, networks)
  //    - Plan check only applies when status changes to ACTIVE
  //    - Job seeker check applies only when role = JOB_SEEKER

  // #  Final check
  // Test for: DRAFTED → ACTIVE, INACTIVE → ACTIVE, ACTIVE → INACTIVE
  // Test roles: JOB_SEEKER and others

  // # Done. Push & test.

  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  uploadFiles: Array<any> = [];
  serverCurrentDate: string;
  servertimedate: string;
  disable_for_draft: boolean = false;
  // Synchronous re-entry guard for updateCandidate() — see the comment there.
  isUpdateInFlight: boolean = false;
  async updateCandidate(statusValueCandidate: 'ACTIVE' | 'INACTIVE' | 'DRAFTED') {
    // `disable_for_draft` only adds a CSS class (styles.scss `.disabled` sets
    // pointer-events: none), which isn't applied until change detection runs —
    // so a fast double-click on Update can enter twice, and both calls reach
    // checkUserPlanValid() -> expiredPopup(), showing the "Not Enough Jobs /
    // Candidate Slots" popup twice. This flag blocks re-entry synchronously.
    if (this.isUpdateInFlight) {
      return;
    }
    this.isUpdateInFlight = true;

    this.candidateSubmit = true;
    this.disable_for_draft = true;
    const form = this.candidatePostForm;
    const oldStatus = this.object.status;
    const newStatus = statusValueCandidate;
    const currentRole = this.userType;

    // Basic patch values
    form.patchValue({
      createdBy: localStorage.getItem('userId'),
      isFeatured: this.object.isFeatured,
      photo: this.photoId ?? this.object.photo
    });

    if (oldStatus === 'DRAFTED' && newStatus !== 'DRAFTED') {
      form.patchValue({
        createdByUserType: currentRole,
        status: 'ACTIVE'
      });
    } else {
      form.get('status').setValue(newStatus);
    }

    //  validation for draft status
    if (newStatus === 'DRAFTED') {
      Object.keys(form.controls).forEach(ctrl => {
        if (!['firstName', 'lastName'].includes(ctrl)) {
          form.get(ctrl).clearValidators();
        }
        form.get(ctrl).updateValueAndValidity();
      });
    }

    // Stop if form is invalid and not a draft status
    if (!form.valid && newStatus !== 'DRAFTED') {
      this.disable_for_draft = false;
      this.isUpdateInFlight = false;
      this.scrollToFirstInvalidControl();
      return;
    }

    // Handle DRAFT save
    if (newStatus === 'DRAFTED') {
      this.isUpdateInFlight = false;
      this.handleDraftConfirmation(newStatus);
      return;
    }

    // Role-based checks before activating and consumption count check from the plan service api form lambda function api
    // IMPORTANT: Only check plan limits when ACTIVATING a candidate (not when updating an already ACTIVE candidate)
    if (newStatus === 'ACTIVE' && oldStatus !== 'ACTIVE') {
      const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "JOBS_CANDIDATES");
      if (!isPlanValid) {
        // Slots exhausted — the popup is up. Re-enable the footer buttons
        // (`disable_for_draft` drives styles.scss `.disabled`, which sets
        // pointer-events: none) so Cancel/Update still work once it's closed,
        // and clear the guard so the user can retry after freeing a slot.
        this.disable_for_draft = false;
        this.isUpdateInFlight = false;
        return;
      }
      if (currentRole === 'JOB_SEEKER') {
        const isActivating = newStatus === 'ACTIVE' && oldStatus !== 'ACTIVE';

        if (isActivating) {
          // Check job seeker profile limit for active candidate
          if (this.planService.JobSeekerUpdate.activeCandidatesCount >= 1) {
            Swal.fire({
              position: "center",
              icon: "info",
              title: "Number of profiles exceeded.",
              text: "You can't create more than 1 profile for yourself as a job seeker.",
              showConfirmButton: true,
              showCancelButton: false,
            });
            this.disable_for_draft = false;
            this.isUpdateInFlight = false;
            return;
          }


        }
      }

    }

    this.updateCandidateAfterValidation(newStatus);
    // Short tail so the second click of a double-click is still blocked while
    // the save request goes out; `disable_for_draft` covers the rest and is
    // reset in afterSaveSuccess().
    setTimeout(() => {
      this.isUpdateInFlight = false;
    }, 500);
  }


  handleDraftConfirmation(status: 'DRAFTED') {
    Swal.fire({
      title: 'Save as Draft',
      text: "Would you like to save it as a draft? You can edit this later.",
      icon: 'info',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.updateCandidateAfterValidation(status);
      } else {
        this.resetDraftForm();
      }
    });
  }


  resetDraftForm() {
    this.commonVariables.jobPostingFlag = false;
    this.searchData.setCommonVariables(this.commonVariables);
    this.modalRef.hide();
    this.candidatePostForm.reset();
    this.primarySkillsSelected = [];
    this.secondarySkillsSelected = [];
    this.otherSelectedStates = [];
  }


  updateCandidateAfterValidation(status: string) {
    if (this.currentOrganizationDetail?.organisationId) {
      this.candidatePostForm.get('organisationId').patchValue(this.currentOrganizationDetail.organisationId);
    }

    const candidateData = this.candidatePostForm.getRawValue();
    candidateData.status = status;

    // Add networks
    const getNetworkIds = (type: string) =>
      (this.selectedNetworks || []).filter(id =>
        this.networks.find(n => n.id === id && n.type === type)
      );

    candidateData.personalNetworksPublished = getNetworkIds('Personal Networks');
    candidateData.memberNetworksPublished = getNetworkIds('Member Networks');
    candidateData.businessNetworksPublished = getNetworkIds('Business Networks');
    const isMarketplaceSelected = (this.selectedNetworks || []).some(id => Number(id) === 1);
    // For Free plan users and Job Seekers, always post to Marketplace
    candidateData.postedToMarketPlace = (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') ? true : isMarketplaceSelected;
    // Step 4: Patch to form if needed (if you use a form control for Publish To)
    this.candidatePostForm.patchValue({ networks: this.selectedNetworks });

    this.saveCandidate(candidateData);
  }


  async saveCandidate(candidateData: any) {
    // Check posting slots availability when activating a candidate
    // IMPORTANT: Only validate plan when ACTIVATING for the first time, NOT when updating an already ACTIVE candidate
    if (candidateData.status === 'ACTIVE' && this.object.status !== 'ACTIVE') {
      const userType = localStorage.getItem('userType');

      // Only business users need posting slots validation
      if (userType !== 'JOB_SEEKER') {
        try {
          this.util.startLoader();

          const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS");

          if (!isPlanValid) {
            this.util.stopLoader();
            // The PricePlanService will show the appropriate popup. Re-enable
            // the footer buttons so the modal stays usable after it's closed.
            this.disable_for_draft = false;
            this.isUpdateInFlight = false;
            return;
          }

          this.util.stopLoader();
        } catch (error) {
          this.util.stopLoader();
          return;
        }
      }
    }

    this.FormData = new FormData();

    if (this.resumeupload) {
      this.FormData.append("resume", this.resumeupload);
      this.resumeupload = "";
    }

    if (this.deleteresume) {
      candidateData.resumeFileId = this?.EditCandidatFile?.fileId;
    }

    const cleanedSummary = (this.candidatePostForm.value.resumeSummary || '').replace(/<img[^>]*>/g, '');
    candidateData.resumeSummary = cleanedSummary;
    candidateData.primaryResume = true;
    candidateData.candidateReferenceId = candidateData.candidateId;
    if (this.membershipType !== 'Free') {
      candidateData.businessId = localStorage.getItem('myBusinessId') || null;
    }

    this.FormData.append("candidate", new Blob([JSON.stringify(candidateData)], { type: "application/json" }));

    // Start upload progress simulation
    this.isUploading = true;
    this.uploadProgress = 0;

    // Simulate progress increments (10%, 20%, 30%, etc.)
    const progressInterval = setInterval(() => {
      if (this.uploadProgress < 90) {
        this.uploadProgress += 10;
      }
    }, 200); // Increment every 200ms

    this.util.startLoader();
    this.apiService.updatePut('candidates/updateCandidate', this.FormData).subscribe({
      next: res => {
        clearInterval(progressInterval);
        this.uploadProgress = 100; // Complete progress

        // Show 100% briefly before hiding
        setTimeout(() => {
          this.isUploading = false;
          this.uploadProgress = 0;
          this.util.stopLoader();

          if (res.code === '00000') {
            this.afterSaveSuccess(res.data?.candidateData, candidateData.status);
          }
        }, 500);
      },
      error: () => {
        clearInterval(progressInterval);
        this.isUploading = false;
        this.uploadProgress = 0;
        this.util.stopLoader();
      }
    });
  }

  afterSaveSuccess(candidate: any, status: string) {
    this.disable_for_draft = false;
    this.CandiIdHighLight = this.candidatePostForm.value.candidateId;
    this.photo = null;
    this.modalService.hide(1);

    Swal.fire({
      position: "center",
      icon: "success",
      title: super.getTextBasedOnStatus(status, status === 'DRAFTED' ? "Draft updated" : "Candidate updated"),
      showConfirmButton: false,
      timer: 2000,
    });

    if (candidate) {
      this.updateStatusAndFilters.emit({ value: "update", candidate });
    }
  }
 

  async savecandidate(currentStatus, updateCandidate) {
    this.FormData = new FormData();
    // Only append resume if it's actually being uploaded (not null/empty)
    if (this.resumeupload != null && this.resumeupload !== '') {
      this.FormData.append("resume", this.resumeupload);
    }
    this.resumeupload = "";
    if (this.deleteresume) {
      updateCandidate.resumeFileId = this?.EditCandidatFile?.fileId
    }
    const textStatus: string = updateCandidate.status;

    if (currentStatus === 'ACTIVE') {
      if (this.object.status === 'ACTIVE') {
        // Already active, just update and save the record
        this.savefinal(updateCandidate);
        return;
      }

      // Check if plan is valid
      const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "JOBS_CANDIDATES");
      if (!isPlanValid) return true;

      // Check job seeker profile limit
      if (this.userType === "JOB_SEEKER" && this.planService.JobSeekerUpdate.activeCandidatesCount >= 1) {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Number of profiles exceeded.",
          text: "You can't create more than 1 profile for yourself as a job seeker.",
          showConfirmButton: true,
          showCancelButton: false,
        });
        return;
      }

      // Activate and save
      updateCandidate.status = 'ACTIVE';
      this.savefinal(updateCandidate);

    } else if (currentStatus === 'INACTIVE' || currentStatus === 'DRAFTED') {

      // For INACTIVE or DRAFTED, directly save with updated status
      updateCandidate.status = currentStatus;
      this.savefinal(updateCandidate);
    }


  }



  savefinal(updateCandidate) {
    const textStatus: string = updateCandidate.status;
    updateCandidate.candidateReferenceId = updateCandidate.candidateId;
    const resumeSummary = this.candidatePostForm.value.resumeSummary || '';
    const cleanedContent = resumeSummary.replace(/<img[^>]*>/g, '');
    updateCandidate.resumeSummary = cleanedContent;
    updateCandidate.primaryResume = true;
    this.FormData.append("candidate", new Blob([JSON.stringify(updateCandidate)], { type: "application/json" }));
    this.util.startLoader();
    this.apiService.updatePut('candidates/updateCandidate', this.FormData).subscribe(res => {
      this.util.stopLoader();
      if (res.code == '00000') {
        this.disable_for_draft = false;
        this.CandiIdHighLight = this.candidatePostForm.value.candidateId
        this.photo = null;
        this.util.stopLoader();
        this.modalService.hide(1);
        Swal.fire({
          position: "center",
          icon: "success",
          title: super.getTextBasedOnStatus(textStatus, textStatus === GigsumoConstants.DRAFTED ? "Draft updated" : "Candidate updated"),
          showConfirmButton: false,
          timer: 2000,
        });
        if (res && res.data && res.data.candidateData) {
          let data: any = {};
          data.value = "update";
          data.candidate = res.data.candidateData;
          this.updateStatusAndFilters.emit(data);
        }
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  createCandidateOnProf(event) {
    if (event.target.checked == true) {
      this.candidatePostForm.get('candidateEmailId').setValidators([Validators.required])
    } else {
      this.candidatePostForm.get('candidateEmailId').clearValidators()
      this.candidatePostForm.get('candidateEmailId').updateValueAndValidity({ emitEvent: false })

    }
  }

  fileBrowseHandler(files) {
    if (files && files.length > 0) {
      this.tempFile = files[0];
      this.prepareFilesList(files);
    }
  }


  otherSelectedStates: any = []

  onOtherPreferedChange(event: any) {
    if (!event.target.checked) {
      this.otherSelectedStates = [];
      this.candidatePostForm.get('otherPreferedStates').setValue([]);
    }
  }

  cancelcloseCandidate() {
    this.resumeupload = "";
    this.fileDragdrop = "";
    this.candidateSubmit = false;
    this.candidatePostForm.get("status").setValue(this.object.status);
    if (this.object.status == 'DRAFTED') {
      if (this.candidatePostForm.value.firstName != null && this.candidatePostForm.value.lastName != null) {
        this.candidatePostForm.get('status').patchValue('DRAFTED');
        this.handleDraftConfirmation('DRAFTED');
      } else {
        this.commonVariables.candidatePostingFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
        this.modalService.hide(1)
        this.candidatePostForm.reset()
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = []

      }
    } else {
      this.activecandidatecancel();
    }
  }
  activecandidatecancel() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      title: 'Cancel Edit?',
      text: "You may lose the changed data if you cancel. Would you like to continue?",
      icon: 'info',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.commonVariables.candidatePostingFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
        this.modalRef.hide();
        this.candidatePostForm.reset()
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = []
      }
    });
  }
  deleteresume: boolean = false;
  removeFiles() {
    if (this.fileDragdrop || this.resumeupload) {
      this.fileDragdrop = '';
      this.resumeupload = "";
      this.deleteresume = true;
      this.FormData = new FormData();  // Reset FormData completely
      const fileInput = $("#fileDropRef")[0];
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }




  deletecandidate(id: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Do you wish to discard?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.apiService.delete('candidates/delete/' + id).subscribe(res => {
          if (res.code == "00000") {
            this.util.stopLoader();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Discarded Sucessfully',
              showConfirmButton: false,
              timer: 1500
            })
            this.candidateReload.emit('reload')
          }
        })
      }
    });
  }
  connectionStatus: string;
  connectionRequestRef: BsModalRef;
  values: any;
  counterpartsDetails: any;


  isInteger(event: any): boolean {
    // Check if 'event.target' exists and is an input element
    if (event.target instanceof HTMLInputElement && event.target.selectionStart !== null) {
      const charCode = (event.which) ? event.which : event.keyCode;
      return !(charCode > 31 && (charCode < 48 || charCode > 57));
    }
    return false;
  }

  // ── Corp-to-Corp conditional fields ──

  get isCorpToCorp(): boolean {
    const val = this.candidatePostForm?.get('engagementType')?.value;
    return val === 'Corp to Corp' || val === 'Corp To Corp';
  }

  onEngagementTypeChange(value: string): void {
    const isC2C = value === 'Corp to Corp' || value === 'Corp To Corp';
    if (isC2C) {
      this.candidatePostForm.get('clientType')?.setValidators([Validators.required]);
      this.candidatePostForm.get('clientName')?.setValidators([Validators.required]);
    } else {
      this.candidatePostForm.get('clientType')?.clearValidators();
      this.candidatePostForm.get('clientName')?.clearValidators();
      this.candidatePostForm.get('clientType')?.setValue(null);
      this.candidatePostForm.get('clientName')?.setValue(null);
      this.candidatePostForm.get('showClientType')?.setValue(false);
      this.candidatePostForm.get('showClientName')?.setValue(false);
    }
    this.candidatePostForm.get('clientType')?.updateValueAndValidity();
    this.candidatePostForm.get('clientName')?.updateValueAndValidity();
  }

}





